import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationAddModelComponent } from '../pages/organization-add-model/organization-add-model.component';
import { Router } from '@angular/router';
import { ApiService } from '../core/api.service';
import { UtilityService } from '../core/global/utility.service';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  t
  ua;
  uc;
  high;
  low;
  medium;
  open;
  inprocess;
  close;
  areallabel = [];
  area = [];
  categorylabel = [];
  category = [];
  userType;
  orgRefID;
  plantRefID;
  orgList = [];
  plantList = [];
  organization_ref_id;
  plant_ref_id;
  firstload = 0;
  dayspassed = '0'
  plantusers = '0';
  reviewHigh
  reviewMed
  reviewLow
  // bar charts start here 
  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels = ['UA', 'UC', 'Total'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData = [
    { data: [0, 0, 0], label: 'By issue Status', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
  ];

  public barchartOption = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 50,
            stepValue: 5,
            userCallback: function (label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }

            }

          },
          scaleLabel: {
            display: true,
            labelString: 'Number  of  Issues'
          }
        }
      ],
      xAxes: [{
        barPercentage: 0.2
      }]
    }
  }
  // bar chart ends here 

  // bar Severity charts start here 



  public barChartsevOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartsevLabels = ['Low', 'Medium', 'High'];
  public barChartsevType = 'bar';
  public barChartsevLegend = true;
  public barChartsevData = [
    {
      label: 'Open',
      data: [],
      backgroundColor: ['#dc828f', '#dc828f', '#dc828f'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#dc828f', '#dc828f', '#dc828f'],
      stack: 'Stack 0',

    },
    {
      label: 'In progress',
      data: [],
      backgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'],
      stack: 'Stack 0',
    },
    {
      label: 'Close',
      data: [],
      backgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'],
      stack: 'Stack 0',
    },

    // { data: [0, 0, 0], label: 'By Severity', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
  ];
  public barchartsevOption = {
    responsive: true,
    scales: {
      yAxes: [
        {

        }
      ],
      xAxes: [{
        barPercentage: 0.3,
        ticks: {
          beginAtZero: true,
          max: 50,
          stepValue: 5,
        },
      }]
    }
  }

  public pieChartsevOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public pieChartsevLabels = ['Category'];
  public pieChartsevType = 'doughnut';
  public pieChartsevLegend = true;
  public pieChartsevData = [
    { data: [0], label: 'By Category', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
  ];

  public piechartsevOption = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            font: {
              size: 12,
            },
            beginAtZero: true,
            max: 50

          }
        }
      ],
      xAxes: [{
        barPercentage: 0.2
      }]
    }
  }











  // pie category charts  ends here 

  // pie area charts start here 
  public pieChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public pieChartLabels = ['Area'];
  public pieChartType = 'doughnut';
  public pieChartLegend = true;
  public pieChartData = [
    { data: [0], label: 'By Area', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
  ];

  public piechartOption = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            max: 50

          }
        }
      ],
      xAxes: [{
        barPercentage: 0.2
      }]
    }
  }

  //pie char for assiged users for observation 2
  public pieChartAssignOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public pieChartAssignLabels = ['Assign Users'];
  public pieChartAssignType = 'bar';
  public pieChartAssignLegend = true;
  public pieChartAssignData = [
    {
      label: 'Open',
      data: [],
      backgroundColor: ['#dc828f', '#dc828f', '#dc828f'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#dc828f', '#dc828f', '#dc828f'],
      stack: 'Stack 0',

    },
    {
      label: 'In progress',
      data: [],
      backgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'],
      stack: 'Stack 0',
    },
    {
      label: 'Close',
      data: [],
      backgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'],
      stack: 'Stack 0',
    },

  ];
  // public pieChartAssignData = [
  //   { data: [0], label: 'By Assign Users', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
  // ];

  public piechartAssignOption = {
    responsive: true,
    layout: {

    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepValue: 5,
            max: 50,

          }
        }
      ],
      xAxes: [{
        barPercentage: 0.2
      }]
    }
  }

  isloaded = 0;
  review: any;
  observation_type: any;
  observation2Selected: any;
  openHigh
  openMed
  openLow
  progressHigh
  progressMed
  progressLow
  closeHigh
  closeMed
  closeLow
  opens = []
  progress = []
  reviews = []
  closed = []
  // bar chart ends here 


  constructor(calendar: NgbCalendar, private _adminService: ApiService, private _utility: UtilityService) {

    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);

  }

  ngOnInit(): void {
    $('[data-widget="treeview"]').Treeview('init');
    this.userType = localStorage.getItem('m_ind_type');
    this.observation2Selected = localStorage.getItem('observation2');
    if (this.userType == 'orgadmin') {
      this.getOrgRefID();
    }
    else if (this.userType == 'plantadmin') {
      this.getOrgRefID();
      this.getPlantRefID()
    }
    else if (this.userType == '5') {
      this.getOrgRefID();
      this.getPlantRefID()
      this.getAssignUser();
    }
    else if (this.userType == 'plantsadmin') {
      this.getOrgRefID();
      this.getPlantRefID()
    }
    else if (this.userType == 'user') {
      this.getOrgRefID();
      this.getPlantRefID()
    }
    else {
      this.getOrg();
      this.getPlants();
    }
  }


  getAssignUser() {
    let data = {}
    let url = "incident/observation2assigned";
    this._adminService.post(url, data).subscribe((response) => {
      for (let i = 0; i < response.emp_name.length; i++) {
        this.opens.push('#dc828f')
        this.closed.push('#c0ca33')
        this.progress.push('#f7ce76')
        this.reviews.push('#90cdc3')

      }
      let total = 0;
      for (let i = 0; i < response.opens.length; i++) {
        total = total + response.opens[i]
      }
      for (let i = 0; i < response.in_progress.length; i++) {
        total = total + response.in_progress[i]
      }
      for (let i = 0; i < response.review.length; i++) {
        total = total + response.review[i]
      }
      for (let i = 0; i < response.closed.length; i++) {
        total = total + response.closed[i]
      }
      if (response.status == 200) {
        this.pieChartAssignLabels = response.emp_name;
        this.pieChartAssignType = 'bar';
        this.pieChartAssignLegend = true;
        this.piechartAssignOption = {
          responsive: true,
          layout: {

          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  stepValue: 5,
                  max: this.roundUp(total) + 10,

                }
              }
            ],
            xAxes: [{
              barPercentage: 0.2
            }]
          }
        }
        this.pieChartAssignData = [
          {
            label: 'Open',
            data: response.opens,
            backgroundColor: this.opens, borderColor: '#000', borderWidth: 0, hoverBackgroundColor: this.opens,
            stack: 'Stack 0',

          },
          {
            label: 'In progress',
            data: response.in_progress,
            backgroundColor: this.progress, borderColor: '#000', borderWidth: 0, hoverBackgroundColor: this.progress,
            stack: 'Stack 0',
          },
          {
            label: 'Review',
            data: response.review,
            backgroundColor: this.reviews, borderColor: '#000', borderWidth: 0, hoverBackgroundColor: this.reviews,
            stack: 'Stack 0',
          },
          {
            label: 'Close',
            data: response.closed,
            backgroundColor: this.closed, borderColor: '#000', borderWidth: 0, hoverBackgroundColor: this.closed,
            stack: 'Stack 0',
          },

        ];
      }
    })
  }




  getDataGroup() {
    this.areallabel = [];
    this.area = [];
    this.categorylabel = [];
    this.category = [];
    let wheredata = [];
    if (this.userType == 'orgadmin' || this.userType == 'superadmin') {
      wheredata = [{ 'field': '`incident_details`.`organization_ref_id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }, { 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == 'plantadmin') {
      wheredata = [{ 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == '5') {
      wheredata = [{ 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == 'plantsadmin') {
      wheredata = [{ 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }

    this.pieChartLabels = ['Category'];
    this.pieChartType = 'doughnut';
    this.pieChartLegend = true;
    this.pieChartData = [
      { data: [0], label: 'Issue By Category', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
    ];

    this.pieChartsevLabels = ['Area']
    this.pieChartsevType = 'doughnut';
    this.pieChartsevLegend = true;

    this.pieChartsevData = [
      //.yAxes[0].ticks.max
      { data: [0], label: 'Issue By Area', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
    ];


    let data = { whereData: wheredata, orgId: this.orgRefID };
    let url = "incident/incident-dashboard-group";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        if (response.data1.length > 0) {
          for (let i = 0; i < response.data1.length; i++) {
            this.areallabel.push(response.data1[i].name);
            this.area.push(response.data1[i].area_count);
            if ((response.data1.length - 1) == i) {

              this.pieChartsevLabels = this.areallabel
              this.pieChartsevType = 'doughnut';
              this.pieChartsevLegend = true;

              this.pieChartsevData = [
                //.yAxes[0].ticks.max
                { data: this.area, label: 'Issue By Area', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
              ];
            }
          }
        } else {
          this.pieChartsevLabels = ['Area']
          this.pieChartsevType = 'doughnut';
          this.pieChartsevLegend = true;

          this.pieChartsevData = [
            //.yAxes[0].ticks.max
            { data: [0], label: 'Issue By Area', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
          ];

        }

        if (response.data.length > 0) {
          for (let i = 0; i < response.data.length; i++) {
            this.categorylabel.push(response.data[i].inc_cat_name);
            this.category.push(response.data[i].incident_count);
            if ((response.data.length - 1) == i) {

              this.pieChartLabels = this.categorylabel;
              this.pieChartType = 'doughnut';
              this.pieChartLegend = true;
              this.pieChartData = [
                { data: this.category, label: 'Issue By Category', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
              ];
            }
          }

        } else {
          this.pieChartLabels = ['Category'];
          this.pieChartType = 'doughnut';
          this.pieChartLegend = true;
          this.pieChartData = [
            { data: [0], label: 'Issue By Category', backgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8', '#4382BB', '#F7CE76', '#DC828F', '#8DA47E', '#90CDC3', '#9AD9DB', '#D29FBC', '#WEB96AA', '#A15098', '#C6AC85', '#828288', '#897C87', '#CA9c95', '#F6AE99', '#EDF6E5', '#6F69AC', '#D9CAB3', '#F5ABC9', '#BEA4C8', '#FFC2B8'] }
          ];

        }
      } else {

      }
    })
  }

  async getUserData() {
    let data = { plantid: this.plantRefID, orgId: this.orgRefID };
    let url = "incident/incident-dashboard-dayuser";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.dayspassed = response.data.length != 0 ? (response.data[0].days < 0 ? 0 : response.data[0].days) : 0;
        this.plantusers = response.datausers.length != 0 ? response.datausers[0].count : 0;
      }
    })
  }

  async getData() {
    let wheredata = [];
    if (this.userType == 'orgadmin' || this.userType == 'superadmin') {

      wheredata = [{ 'field': '`incident_details`.`organization_ref_id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }, { 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }

    if (this.userType == 'plantadmin') {
      wheredata = [{ 'field': '`incident_details`.`organization_ref_id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }, { 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == '5') {
      wheredata = [{ 'field': '`incident_details`.`organization_ref_id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }, { 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == 'plantsadmin') {
      wheredata = [{ 'field': '`incident_details`.`organization_ref_id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }, { 'field': '`incident_details`.`plant_ref_id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    let data = { whereData: wheredata, orgId: this.orgRefID };
    let url = "incident/incident-dashboard";
    //if(this.isloaded==0){
    this._utility.showLoader();
    //}
    this._adminService.post(url, data).subscribe((response) => {
      //if(this.isloaded==0){
      this._utility.hideLoader();
      //   this.isloaded = 1;
      // }
      if (response.success == true) {

        //this.orgRefID= response.data[0].organization_ref_id; 
        //this.getData();
        this.ua = response.data[0].ua;
        this.uc = response.data[0].uc;
        this.high = response.data[0].high;
        this.low = response.data[0].low;
        this.medium = response.data[0].medium;

        this.open = response.data[0].open;
        this.inprocess = response.data[0].inprocess;
        this.close = response.data[0].close;
        this.review = response.data[0].review;
        this.openHigh = response.data[0].openhigh
        this.openMed = response.data[0].openmed
        this.openLow = response.data[0].openlow
        this.progressHigh = response.data[0].inprogressHigh
        this.progressMed = response.data[0].inprogressMedium
        this.progressLow = response.data[0].inprogressLow
        this.closeHigh = response.data[0].closeHigh
        this.closeMed = response.data[0].closeMedium
        this.closeLow = response.data[0].closeLow
        this.reviewHigh = response.data[0].reviewHigh
        this.reviewMed = response.data[0].reviewMedium
        this.reviewLow = response.data[0].reviewLow
        this.observation_type = response.data[0].observation_type;
        if (this.observation_type == 2) {
          this.barChartLabels = ['Open', 'In Progress', 'Review', 'Closed'];
          this.barchartOption = { responsive: true, scales: { yAxes: [{ ticks: { beginAtZero: true, max: this.roundUp(this.open + this.inprocess + this.review + this.close + 10), stepValue: 5, userCallback: function (label, index, labels) { if (Math.floor(label) === label) { return label; } } }, scaleLabel: { display: true, labelString: 'Number  of  Issues' } }], xAxes: [{ barPercentage: 0.2 }] } }
        } else {
          this.barChartLabels = ['Open', 'In Progress', 'Closed'];
          this.barchartOption = { responsive: true, scales: { yAxes: [{ ticks: { beginAtZero: true, max: this.roundUp(this.open + this.inprocess + this.close + 10), stepValue: 5, userCallback: function (label, index, labels) { if (Math.floor(label) === label) { return label; } } }, scaleLabel: { display: true, labelString: 'Number  of  Issues' } }], xAxes: [{ barPercentage: 0.2 }] } }
        }
        this.barChartType = 'bar';
        this.barChartLegend = true;
        if (this.observation_type == 2) {
          this.barChartData = [
            //.yAxes[0].ticks.max
            { data: [this.open, this.inprocess, this.review, this.close], label: 'Issue Status', backgroundColor: ['#DC828F', '#F7CE76', '#90CDC3', '#c0ca33'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: [] }
          ];

        } else {
          this.barChartData = [
            //.yAxes[0].ticks.max
            { data: [this.open, this.inprocess, this.close], label: 'Issue Status', backgroundColor: ['#DC828F', '#F7CE76', '#c0ca33'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: [] }
          ];
        }

        this.barchartsevOption = {
          responsive: true, scales: {
            yAxes: [{ ticks: { beginAtZero: true, max: this.roundUp(this.high + this.low + this.medium + 10), stepValue: 5, userCallback: function (label, index, labels) { if (Math.floor(label) === label) { return label; } } }, scaleLabel: { display: true, labelString: 'Number  of  Issues' } }], xAxes: [{
              barPercentage: 0.2, ticks: {
                beginAtZero: true,
                max: 50,
                stepValue: 5,
              },
            }]
          }
        }
        this.barChartsevLabels = ['High', 'Medium', 'Low',];
        this.barChartsevType = 'bar';
        this.barChartsevLegend = true;
        if (this.observation_type == 1) {
          this.barChartsevData = [
            {
              label: 'Open',
              data: [this.openHigh, this.openMed, this.openLow],
              backgroundColor: ['#dc828f', '#dc828f', '#dc828f'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#dc828f', '#dc828f', '#dc828f'],
              stack: 'Stack 0',

            },
            {
              label: 'In progress',
              data: [this.progressHigh, this.progressMed, this.progressLow],
              backgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'],
              stack: 'Stack 0',
            },

            {
              label: 'Close',
              data: [this.closeHigh, this.closeMed, this.closeLow],
              backgroundColor: ['#c0ca33', '#c0ca33', '#c0ca33'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#c0ca33', '#c0ca33', '#c0ca33'],
              stack: 'Stack 0',
            },

            // { data: [0, 0, 0], label: 'By Severity', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
          ];
        } else {
          this.barChartsevData = [
            {
              label: 'Open',
              data: [this.openHigh, this.openMed, this.openLow],
              backgroundColor: ['#dc828f', '#dc828f', '#dc828f'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#dc828f', '#dc828f', '#dc828f'],
              stack: 'Stack 0',

            },
            {
              label: 'In progress',
              data: [this.progressHigh, this.progressMed, this.progressLow],
              backgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#f7ce76', '#f7ce76', '#f7ce76'],
              stack: 'Stack 0',
            },
            {
              label: 'Review',
              data: [this.reviewHigh, this.reviewMed, this.reviewLow],
              backgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#90cdc3', '#90cdc3', '#90cdc3'],
              stack: 'Stack 0',
            },
            {
              label: 'Close',
              data: [this.closeHigh, this.closeMed, this.closeLow],
              backgroundColor: ['#c0ca33', '#c0ca33', '#c0ca33'], borderColor: '#000', borderWidth: 0, hoverBackgroundColor: ['#c0ca33', '#c0ca33', '#c0ca33'],
              stack: 'Stack 0',
            },

            // { data: [0, 0, 0], label: 'By Severity', backgroundColor: ['#17a2b8'], borderColor: '#000', borderWidth: 2, hoverBackgroundColor: ['rgba(63, 191, 127, 0.6)', 'rgba(63, 191, 191, 0.6)'] }
          ];
        }



      }
    })
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  async getOrgRefID() {
    let data = {};
    let url = "plant/orgdetails";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.orgRefID = response.data[0].organization_ref_id;
        this.getOrg();

      }
    })
  }
  async getPlantRefID() {
    let data = {};
    let url = "plant/plantdetails";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.plantRefID = response.data[0].plant_ref_id;
        //this.getOrg();
        //this.areaOrg(this.orgRefID);
        this.getPlants();
      }
    })
  }
  async getOrg() {
    let url = "org/list";
    let wheredata;

    if (this.userType == 'orgadmin') {
      wheredata = [{ 'field': '`organization`.`id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }];
    }

    if (this.userType == 'plantadmin') {
      wheredata = [{ 'field': '`organization`.`id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }];
    }
    if (this.userType == '5') {
      wheredata = [{ 'field': '`organization`.`id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }];
    }
    if (this.userType == 'plantsadmin') {
      wheredata = [{ 'field': '`organization`.`id`', 'value': this.orgRefID, 'type': 'AND', 'nested': '' }];
    }

    let data = { searchText: '', sortby: '', page: 0, whereData: wheredata };
    this._adminService.post(url, data).subscribe((response) => {
      if (response.status == 200) {
        this.orgList = response.data;
        if (this.orgList.length > 0) {
          this.organization_ref_id = this.orgList[0].id;
          this.onOrgChange(this.orgList[0].id);
        }


      } else {
      }
    })
  }

  async getPlants() {
    let url = "plant/list";
    let wheredata;
    if (this.userType == 'plantadmin') {
      wheredata = [{ 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == '5') {
      wheredata = [{ 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == 'plantsadmin') {
      wheredata = [{ 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    let data = { searchText: '', sortby: '', page: 0, whereData: wheredata };
    this._adminService.post(url, data).subscribe((response) => {
      if (response.status == 200) {
        this.plantList = response.data;
        if (this.userType == 'plantadmin') {
          //this.onOrgChange(this.orgRefID)
        }
      } else {
      }
    })
  }
  onPlantChange(event) {
    this.plantRefID = event;
    if (this.userType == "superadmin") {
      this.orgRefID = this.organization_ref_id;
      this.getData();
      this.getDataGroup();
      this.getUserData();
    } else {
      let selected = window.localStorage.getItem('selectedItem')
      let data = JSON.parse(selected);
      if (data.issue_selected == 1 || data.observation2_selected == 1) {
        this.getData();
        this.getDataGroup();
        this.getUserData();
      }
    }
  }
  onOrgChange(event) {
    // change plant;
    let url = "plant/list";
    let wheredata = [{ 'field': '`plant`.`organization_ref_id`', 'value': event, 'type': 'AND', 'nested': '' }]

    if (this.userType == 'plantadmin') {
      wheredata = [{ 'field': '`plant`.`organization_ref_id`', 'value': event, 'type': 'AND', 'nested': '' }, { 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == '5') {
      wheredata = [{ 'field': '`plant`.`organization_ref_id`', 'value': event, 'type': 'AND', 'nested': '' }, { 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    if (this.userType == 'plantsadmin') {
      wheredata = [{ 'field': '`plant`.`organization_ref_id`', 'value': event, 'type': 'AND', 'nested': '' }, { 'field': '`plant`.`id`', 'value': this.plantRefID, 'type': 'AND', 'nested': '' }]
    }
    //[{'field':'`plant`.`organization_ref_id`','value':event,'type':'AND','nested':'('},{'field':'`plant`.`area_ref_id`','value':1,'type':'AND','nested':')'}]
    let data = { searchText: '', sortby: 'id', page: 0, whereData: wheredata };
    this._adminService.post(url, data).subscribe((response) => {
      if (response.status == 200) {
        this.plantList = response.data;
        if (this.plantList.length > 0) {
          this.plant_ref_id = '';
          if (this.plantList.length > 0) {
            this.onPlantChange(this.plantList[0].id);
            this.plant_ref_id = this.plantList[0].id;
            if (this.userType == 'orgadmin' && event == 1) {  // choosing for rohan oberoi 
              if (this.firstload == 0) {
                /*setTimeout(function(){
                 // alert(123);
                  this.onPlantChange(6);
                  this.plant_ref_id = 6;
                  this.plantRefID = 6;
                  this.firstload = 1;

                 }, 3000); */

              }
            }


          }

        }
      }
    })
  }

  roundUp(n) {
    if (n == 0) {
      n = 10;
    }
    else if (n % 2 == 1) {
      return n = n + 1
    }
    // else if (n % 5 == 1) {
    //   return n = n + 4
    // }
    // else if (n % 5 == 2) {
    //   return n = n + 3
    // }
    // else if (n % 5 == 3) {
    //   return n = n + 2
    // }
    // else if (n % 5 == 4) {
    //   return n = n + 1
    // }
    return Math.ceil(n / 5) * 5;
  }


}
